import { useTranslation } from 'react-i18next';
import { useBoardStore } from '../state/board-store.js';
import { BulletinPanel } from './BulletinPanel.js';
import { InteractionMenu } from './InteractionMenu.js';
import { WhiteboardPanel } from './WhiteboardPanel.js';

/** The drink menu, whiteboard and bulletin board, shown when the server opens them (ADR-0029). */
export function OfficeBoards() {
  const { t } = useTranslation();
  const whiteboard = useBoardStore((s) => s.whiteboard);
  const bulletin = useBoardStore((s) => s.bulletin);
  const failed = useBoardStore((s) => s.boardFailed);
  return (
    <>
      <InteractionMenu />
      {failed && (
        <div className="hud-box board-failed" role="alert">
          {t('whiteboard.failed')}{' '}
          <button
            type="button"
            className="link"
            onClick={() => useBoardStore.getState().setBoardFailed(false)}
          >
            ×
          </button>
        </div>
      )}
      {whiteboard && <WhiteboardPanel board={whiteboard} />}
      {bulletin && <BulletinPanel board={bulletin} />}
    </>
  );
}
